export enum ProjectsFilterType {
    All = "all",
    Active = "active",
    NotShared = "notShared",
}
